'use client'

import {getCurrentPathIn} from '../browser/location'
import {Locale} from '../constants'
import {useNavigation} from './useNavigation'

export const useSwitchLanguage = () => {
  const {replace} = useNavigation()

  return async (locale: Locale) => {
    const path = getCurrentPathIn(locale)
    await replace(path, {locale})
  }
}
